import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import PropTypes from "prop-types";
import React from "react";
import SwipeableViews from "react-swipeable-views";
import HospitalVicinity from "./subcomponents/HospitalVicinity";
import MallVicinity from "./subcomponents/MallVicinity";
import OthersVicinity from "./subcomponents/OthersVicinity";
import SchoolVicinity from "./subcomponents/SchoolVicinity";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "flex-start",
  },
  tab: {},
  tabContent: {
    display: "flex",
    color: "#666666",
    padding: "1.5rem 0rem 0rem 0rem",
    overflow: "hidden",
    position: "relative",
    fontSize: "1rem",
    fontWeight: "400",
    maxWidth: "264px",
    textTransform: "capitalize",
    minWidth: "2rem",
    margin: "0rem 6.625rem 0rem 0rem",
    boxSizing: "border-box",
    minHeight: "4px",
    textAlign: "center",
    flexShrink: 0,
    fontWeight: 500,
    textTransform: "capitalize",
    [theme.breakpoints.down("xs")]: {
      margin: "0rem 1.1rem 0rem 0rem",
    },
  },
  timeButtons: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "0.875rem",

    width: "100%",
  },
  timeButton: {
    padding: "0.5rem 1rem",
    fontSize: "0.813rem",
    lineheight: "1.125rem",
    fontWeight: "400",
    color: "#693471",
    background: "#FFFFFF",
    border: "1px solid #69347152",
    borderRadius: "1rem",
    cursor: "pointer",
    transition: "background-color 0.2s ease, color 0.2s ease",
    textTransform: "capitalize",
    "&:hover": {
      background: "#F3E5F5",
    },
    "&:focus, &:active": {
      background: "#693471",
      color: "#FFFFFF",
    },
  },
  activeTimeButton: {
    background: "#693471",
    color: "#FFFFFF",
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      style={{ width: "100%" }}
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ padding: "1.063rem 0rem 0rem 0rem" }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const VicinityTab = (props) => {
  const theme = useTheme();
  const classes = useStyles();
  const isSmallDevice = useMediaQuery((theme) => theme.breakpoints.down("sm")); // Detect small devices
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    typeof props.onChange === "function" ? props.onChange(newValue) : undefined;
    setValue(newValue);
  };

  const handleButtonClick = (index) => {
    typeof props.onChange === "function" ? props.onChange(index) : undefined;
    setValue(index);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  return (
    <div>
      {isSmallDevice ? (
        <div className={classes.timeButtons}>
          <Button
            className={`${classes.timeButton} ${value === 0 ? classes.activeTimeButton : ""}`}
            variant="outlined"
            onClick={() => handleButtonClick(0)}
          >
            Schools
          </Button>
          <Button
            className={`${classes.timeButton} ${value === 1 ? classes.activeTimeButton : ""}`}
            variant="outlined"
            onClick={() => handleButtonClick(1)}
          >
            Malls
          </Button>
          <Button
            className={`${classes.timeButton} ${value === 2 ? classes.activeTimeButton : ""}`}
            variant="outlined"
            onClick={() => handleButtonClick(2)}
          >
            Hospitals
          </Button>
          <Button
            className={`${classes.timeButton} ${value === 3 ? classes.activeTimeButton : ""}`}
            variant="outlined"
            onClick={() => handleButtonClick(3)}
          >
            More
          </Button>
        </div>
      ) : (
        <Box className={classes.root}>
          <Tabs
            value={value}
            textColor="secondary"
            TabIndicatorProps={{
              style: {
                backgroundColor: "#74378E",
              },
            }}
            className={classes.tab}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            sx={{ marginRight: 0 }}
          >
            <Tab
              className={classes.tabContent}
              label="Schools"
              {...a11yProps(0)}
            />
            <Tab
              className={classes.tabContent}
              label="Malls"
              {...a11yProps(1)}
            />
            <Tab
              className={classes.tabContent}
              label="Hospitals"
              {...a11yProps(2)}
            />
            <Tab
              className={classes.tabContent}
              label="More"
              {...a11yProps(3)}
            />
          </Tabs>
        </Box>
      )}
      <SwipeableViews
        axis={theme.direction === "rtl" ? "x-reverse" : "x"}
        index={value}
        onChangeIndex={handleChangeIndex}
      >
        <TabPanel
          value={value}
          index={0}
          dir={theme.direction}
        >
          <SchoolVicinity />
        </TabPanel>
        <TabPanel
          value={value}
          index={1}
          dir={theme.direction}
        >
          <MallVicinity />
        </TabPanel>
        <TabPanel
          value={value}
          index={2}
          dir={theme.direction}
        >
          <HospitalVicinity />
        </TabPanel>
        <TabPanel
          value={value}
          index={3}
          dir={theme.direction}
        >
          <OthersVicinity />
        </TabPanel>
      </SwipeableViews>
    </div>
  );
};

export default VicinityTab;
